import InputField from "components/fields/InputField";
import Checkbox from "components/checkbox";
import { useEffect, useState } from "react";
import { validateAdminSignIn } from "common/validation";
import { useDispatch, useSelector } from "react-redux";
import { signInUserThunk } from "slices/userSlice";

export default function SignIn() {
  const [userData, setUserData] = useState({
    email: "",
    password: "",
    checkbox: false,
  });
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const dispatch = useDispatch();
  const signInUser=useSelector((state) => state);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if(name==="checkbox"){
      setUserData((prevData) => ({
        ...prevData,
        [name]: e.target.checked,
      }));
      return;
    }
    const updated = { ...userData, [name]: value };
    setUserData(updated);

    const fieldError = validateAdminSignIn(updated);
    setErrors({ ...errors, [name]: fieldError[name] ?? "" });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateAdminSignIn(userData);
    setErrors(validationErrors);

    const isValid = Object.values(validationErrors).every((x) => x === "");
    if (!isValid) return;
    if(userData.checkbox){
      localStorage.setItem("rememberMe", JSON.stringify(userData));
    }
dispatch(signInUserThunk(userData))
  };
  useEffect(() => {
    const rememberMe = localStorage.getItem("rememberMe");
    if (rememberMe) {
      setUserData(JSON.parse(rememberMe));
    }
  },[])
  useEffect(() => {
    if(signInUser?.users?.data?.accessToken){
      localStorage.setItem("accessToken", signInUser?.users?.data?.accessToken);
      localStorage.setItem("user", JSON.stringify(signInUser?.users?.data));
      window.location.href = "/admin";
    }
  },[signInUser]);
  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your email and password to sign in!
        </p>
    
        <InputField
          variant="auth"
          extra="mb-3"
          label="Email*"
          placeholder="mail@simmmple.com"
          id="email"
          type="text"
          name="email"
          value={userData.email}
          onChange={handleChange}

        />
           {errors.email && (
          <p className="text-red-500 text-sm mb-2">{errors.email}</p>
        )}
        {/* Password */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Password*"
          name="password"
          placeholder="Min. 8 characters"
          id="password"
          type="password"
                   value={userData.password}
       onChange={handleChange}
        />
           {errors.password && (
          <p className="text-red-500 text-sm mb-2">{errors.password}</p>
        )}
        {/* Checkbox */}
        <div className="mb-4 flex items-center justify-between px-2">
          <div className="flex items-center">
            <Checkbox name="checkbox" onChange={handleChange} checked={userData?.checkbox} />
            <p className="ml-2 text-sm font-medium text-navy-700 dark:text-white">
              Keep me logged In
            </p>
          </div>
          <a
            className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            href=" "
          >
            Forgot Password?
          </a>
        </div>
        <button onClick={handleSubmit} className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
          Sign In
        </button>
  
      </div>
    </div>
  );
}
